import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { NavLink, useNavigate } from 'react-router-dom';

import { Button, Card, Variant } from '@indicia/component-library';
import useBem from '@indicia/use-bem';

import Icon from '../../../shared/components/button/enums/Icon';
import DashboardBanner from '../../../shared/components/dashboard-banner/DashboardBanner';
import StatisticsButtonType from '../../../shared/components/dashboard-banner/enums/StatisticsButtonType';
import Dialog from '../../../shared/components/dialog/Dialog';
import IconRender from '../../../shared/components/icon/IconRender';
import Improvements from '../components/improvements/Improvements';
import useResultContext from '../store/UseResultContext';

const DashboardHomePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { bemClassName } = useBem('dashboard');
  const { result } = useResultContext();
  const [showDialog, setShowDialog] = useState<boolean>(false);

  const { echteLeeftijd, inputLeeftijd, topImprovements } = result;

  const toggleDialog = () => {
    setShowDialog(!showDialog);
  };

  const linkToThemesPage = () => {
    navigate('/thema');
  };

  return (
    <div className={bemClassName('homepage-container')}>
      <DashboardBanner
        inputAge={inputLeeftijd ?? 0}
        realAge={echteLeeftijd ?? 0}
        showParagraphAndTitleOnMobile={false}
        statisticsButtonType={StatisticsButtonType.Mail}
        onStatisticsButtonClick={linkToThemesPage}
        title={t('dashboard.homepage.banner.title')}
        paragraph={t('dashboard.homepage.banner.paragraph')}
        showBreadcrumb={false}
        disableSticky
      />

      <div className={bemClassName('improvements-container')}>
        <h2 className={bemClassName('header')}>{t('dashboard.homepage.better')}</h2>
        <p className={bemClassName('subtitle')}>{t('dashboard.homepage.better-description')}</p>
        <Improvements improvements={topImprovements ?? []} />
        <NavLink
          className="link"
          to="/improvements"
        >
          <Button variant={Variant.Outlined}>
            {t('dashboard.more-insights')}
            <IconRender
              icon={Icon.arrowRight}
              color="currentColor"
            />
          </Button>
        </NavLink>
      </div>

      <div className={bemClassName('more-insights-container')}>
        <Card
          customClasses={bemClassName('test-result-card')}
          title={t('dashboard.insights.title') ?? ''}
          description={t('dashboard.insights.description') ?? ''}
        >
          <NavLink to="/thema">
            {t('dashboard.insights.change-answers')}
            <IconRender
              icon={Icon.arrowRight}
              color="currentColor"
            />
          </NavLink>
        </Card>
        <Card
          customClasses={bemClassName('compliment-card')}
          title={t('dashboard.suggestion.title') ?? ''}
          description={t('dashboard.suggestion.description') ?? ''}
        >
          <NavLink to="/suggestions">
            {t('dashboard.suggestion.suggestions')}
            <IconRender
              icon={Icon.arrowRight}
              color="currentColor"
            />
          </NavLink>
        </Card>
      </div>

      {showDialog && (
        <Dialog
          onClose={toggleDialog}
          title={t('dashboard.dialog.title')!}
          content={
            <Trans
              i18nKey="dashboard.dialog.content"
              components={{ 1: <br /> }}
            />
          }
        />
      )}
    </div>
  );
};

export default DashboardHomePage;
